/// <reference path="../../typings/tsd.d.ts" /> 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ProcessSubTypeService = /** @class */ (function (_super) {
            __extends(ProcessSubTypeService, _super);
            function ProcessSubTypeService(injectedBreeze, $q, $http, securityMatrixService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.securityMatrixService = securityMatrixService;
                return _this;
            }
            ProcessSubTypeService.prototype.createConfig = function (processConfig) {
                var newProcessSubTypeConfiguration = this.createNewEntity("ProcessSubTypeConfiguration");
                newProcessSubTypeConfiguration.header = "Select Process Sub Type";
                newProcessSubTypeConfiguration.dropdownLabel = "Process Sub Type";
                newProcessSubTypeConfiguration.buttonLabel = "Create Process";
                this.createNewSubType(newProcessSubTypeConfiguration);
                processConfig.mySubTypeConfiguration = newProcessSubTypeConfiguration;
                processConfig.subTypeConfiguration_id = newProcessSubTypeConfiguration.id;
            };
            ProcessSubTypeService.prototype.createNewSubType = function (processSubTypeConfiguration) {
                var newProcessSubType = this.createNewEntity("ProcessSubType");
                newProcessSubType.name = "New Sub Type";
                newProcessSubType.displayName = "";
                newProcessSubType.isActive = true;
                newProcessSubType.uniqueIdentifier = services.UtilityService.generateGuidComb();
                newProcessSubType.myProcessSubTypeConfiguration = processSubTypeConfiguration;
                newProcessSubType.processSubTypeConfiguration_id = processSubTypeConfiguration.id;
                var securityMatrix = this.securityMatrixService.createSecurityRow(false);
                var matrix = { "00000000-0000-0000-0000-000000000000": {
                        alwaysVisible: true
                    } };
                securityMatrix.matrixJson = JSON.stringify(matrix);
                newProcessSubType.myCreateSecurityMatrix = securityMatrix;
                newProcessSubType.securityMatrix_id = securityMatrix.id;
                processSubTypeConfiguration.myProcessSubTypes.push(newProcessSubType);
                return newProcessSubType;
            };
            ProcessSubTypeService.prototype.getExecutionProcessSubTypes = function () {
                var d = this.$q.defer();
                this.$http.get('./api/ProcessType/SubTypes').then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            return ProcessSubTypeService;
        }(services.DataService));
        services.ProcessSubTypeService = ProcessSubTypeService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ProcessSubTypeService', ['breeze', '$q', '$http', 'securityMatrixService']);
